/* global SignWellEmbed */

import { Controller } from "@hotwired/stimulus";

// Connects to data-controller="signwell"
export default class extends Controller {
  static values = { url: String };

  open() {
    const signWellEmbed = new SignWellEmbed({
      url: this.urlValue,
      events: {
        completed: (e) => {
          console.log("completed event: ", e);
          // document successfully signed/completed
          this.#submitForVerification();
        },
        closed: (e) => {
          console.log("closed event: ", e);
          // document was closed
          this.#submitForVerification();
        },
      },
    });

    signWellEmbed.open();
  }

  #submitForVerification() {
    this.element.requestSubmit();
  }
}
